export default __webpack_public_path__ + "static/media/more-bread.cd5d3ee9.png";